import { httpClient } from '@/api/http-client'
import { Partner } from '@/types'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type Params = {
  companyKey: string
  partnerKey: string
  data: {
    month: number
    year: number
    amount: number
  }
}

export const createPartnerMonthlyWithdraw = async ({
  companyKey,
  partnerKey,
  data,
}: Params) => {
  const response = await httpClient('accounting-dealer').post<Partner>(
    `/v3/company/${companyKey}/partner/${partnerKey}/monthly-withdraw`,
    data,
  )
  return response.data
}

export const useCreatePartnerMonthlyWithdraw = (
  options?: UseMutationOptions<Partner, AxiosError, Params>,
) => {
  return useMutation({
    mutationFn: createPartnerMonthlyWithdraw,
    ...options,
  })
}
